import { useReveal } from '../hooks/UseReveal';
import { useState, useEffect } from "react";

import SpecialText from '../fragments/SpecialText';
import SmartLink from '../fragments/SmartLink';

export default function CallToAction({ block }) {

    const [blockLoaded, setBlockLoaded] = useState(false);

    useEffect(() => {
        setBlockLoaded(true);
    }, []);

    const textRevealRef = useReveal({ once: true });
    const text_maximum_width = block.text_maximum_width ? block.text_maximum_width + 'em' : '30em';

    return (
        <div id={block.section_id} className={`c-page__block c-page__block--call-to-action`}>
             <div className={`l-grid`}>
                <div className={`l-grid__col`}>
                    <div className="c-quote c-transition-in--top-border c-transition" ref={textRevealRef}>
                        <div className="l-small-top-padding">
                            {block.text &&
                                <h3 className="c-quote__text c-heading" style={{ maxWidth: text_maximum_width }}>
                                    <SpecialText text={block.text} />
                                </h3>
                            }
                            {block.link_text && block.link_url &&
                                <p className="c-quote__button c-paragraph">
                                    <SmartLink
                                        link={block.link_url}
                                    >{block.link_text}</SmartLink>
                                </p>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}